module.exports = __webpack_public_path__ + "static/Truck2-1a23f201f4a525a387119615eaaf0e48.png";